import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

export const travelVipApi = {
  getMyEntitlements: () => travelClient.get(travelEndpoints.myVipEntitlements),
};
